// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sc-message--emoji[data-v-31eb6bba]{font-size:40px}", ""]);
// Exports
module.exports = exports;
